import type { CreativeCredit } from 'sr-types/lib/person/v1/graphql';
import type { WorkEntryRow } from '../types';
import { buildRowsWithStableIds, formatYearRangeFromDates, getYearsFromDateRange, parseRoleLabels } from './shared';

function getCreativeCreditBaseId(credit: CreativeCredit): string {
    const showId = credit.showReference?.id ?? credit.showName ?? '';
    const roles = (credit.professionalRoles?.filter(Boolean) as string[]) ?? [];
    const start = credit.dateRange?.start ?? '';
    return `${showId}|${roles.join(',')}|${start}`;
}

function toCreativeCreditRow(credit: CreativeCredit, id: string): WorkEntryRow<CreativeCredit> {
    const roleLabels = parseRoleLabels(credit.professionalRoles);
    const searchText = [credit.showName, credit.showType, ...roleLabels].filter(Boolean).join(' ').toLowerCase();

    return {
        id,
        source: credit,
        primaryTitle: credit.showName ?? '',
        secondaryLine: credit.showType || undefined,
        roleLabels,
        yearRange: formatYearRangeFromDates(credit.dateRange?.start, credit.dateRange?.end) || undefined,
        location: credit.location?.label?.trim() || undefined,
        typeValue: credit.showType || undefined,
        years: getYearsFromDateRange(credit.dateRange?.start, credit.dateRange?.end),
        searchText,
        isKey: !!credit.keyCredit
    };
}

export function buildCreativeCreditRows(credits: ReadonlyArray<CreativeCredit>): WorkEntryRow<CreativeCredit>[] {
    return buildRowsWithStableIds(credits, getCreativeCreditBaseId, toCreativeCreditRow);
}
